import * as React from "react";
import { Box, LinearProgress } from "@material-ui/core";
import { BoxProps } from "@material-ui/core/Box";
import { LinearProgressProps } from "@material-ui/core/LinearProgress";
import { useTheme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import { themeVariables } from "./_Theme";

interface IProps extends BoxProps {
  data?: LinearProgressProps;
  size?: "sm" | "xs";
  type?: "green" | "red" | "orange";
  reversed?: boolean;
}

export const MUIProgressBar = ({
  data,
  size,
  type,
  reversed,
  ...boxProps
}: IProps) => {
  const theme = useTheme();

  const classes = makeStyles({
    LinearProgress: {
      height: 16,
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: themeVariables.palette.border,
      backgroundColor: theme.palette.grey.A400,
      borderRadius: theme.shape.borderRadius,
    },
    Small: {
      height: 10,
      borderRadius: theme.shape.borderRadius * 2,
    },
    XSmall: {
      height: 6,
      borderRadius: theme.shape.borderRadius * 2,
    },
    reversed: {
      transformOrigin: "50% 50%",
      transform: "rotate(180deg)",
    },
  })({});

  return (
    <Box {...boxProps}>
      <LinearProgress
        className={`${classes.LinearProgress} ${
          size === "sm" ? classes.Small : size === "xs" ? classes.XSmall : null
        } ${type} ${reversed ? classes.reversed : ""}`}
        {...data}
      />
    </Box>
  );
};
